import { render } from "./Lighbox.vue?vue&type=template&id=2e98cff7&scoped=true"
import script from "./Lighbox.vue?vue&type=script&lang=js"
export * from "./Lighbox.vue?vue&type=script&lang=js"

import "./Lighbox.vue?vue&type=style&index=0&id=2e98cff7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e98cff7"]])

export default __exports__